import React from 'react';
import { ModalOverlay, ModalContent, ModalTitle, ModalText, ModalButton } from './styles';
import { useTranslation } from "contexts/Safra/TranslationContext";

export default function WelcomeModal({ isOpen, onClose }) {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <ModalOverlay>
            <ModalContent>
                <ModalTitle>
                    {t('safra.components.welcome_modal.title')}
                </ModalTitle>
                <ModalText>
                    {t('safra.components.welcome_modal.text')}
                </ModalText>
                <ModalButton onClick={onClose}>
                    {t('safra.common.continue').toUpperCase()}
                </ModalButton>
            </ModalContent>
        </ModalOverlay>
    );
}
